import React, { Component } from 'react'
import { toast } from 'react-toastify';
import api from '../../services/api';

class Painel extends Component {
    
    constructor(props){
        
        super(props);

        this.state = {
           vendas:'',
           todos:0,
           naoInicia: 0,
           aprovadas:0,
           producao:0,
           pagos:0,
           isCarregar:true,
        }
    }

    async componentDidMount() {
        const token         = sessionStorage.getItem('token');
      
        const dataFilter = await api.get('/api/home', {
            headers: {
                'x-access-token':token,
            }
        }).catch((e)=> {
            this.setState({
                isCarregar:false,
                vendas:[],
                todos: 0,
                naoInicia: 0,
                aprovadas: 0,
                producao: 0,
                pagos: 0,
            })
        })  
        
        var faturamento = dataFilter.data;
       
        const naoInicia   =  faturamento.vendas.filter(function(value){ return value.status == 1;});
        const aprovadas =  faturamento.vendas.filter(function(value){ return value.status == 2;});
        const producao =  faturamento.vendas.filter(function(value){ return value.status == 3;});
        const pagos =  faturamento.vendas.filter(function(value){ return value.status == 5;})

        
        this.setState({
            isCarregar:false,
            vendas:faturamento.vendas,
            todos: faturamento.vendas.length,
            naoInicia: naoInicia.length,
            aprovadas:aprovadas.length,
            producao:producao.length,
            pagos:pagos.length,
            isCarregar:false,
        })
    

        
    }
    
    
    render() {
        return (      
            <div class="container-fluid">
                <div class="row">

                    <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box mb-3">
                            <span class="info-box-icon bg-danger elevation-1"><i class="fas fa-exclamation-circle"></i></span>

                            <div class="info-box-content">
                                <span class="info-box-text">O.S Não Iniciadas</span>
                                <span class="info-box-number">{this.state.naoInicia}</span>
                            </div>
                            { this.state.isCarregar ? 
                                <div class="overlay d-flex justify-content-center align-items-center">
                                    <i class="fas fa-2x fa-sync fa-spin"></i>
                                    </div>
                                : ''
                            }
                        </div>
                    </div>
                    <div class="clearfix hidden-md-up"></div>
                    
                    <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box">
                            <span class="info-box-icon bg-info elevation-1"><i class="fas fa-tags"></i></span>

                            <div class="info-box-content">
                                <span class="info-box-text">O.S Pendentes</span>
                                <span class="info-box-number">
                                { this.state.aprovadas }
                                </span>
                            </div>
                            { this.state.isCarregar ? 
                                <div class="overlay d-flex justify-content-center align-items-center">
                                    <i class="fas fa-2x fa-sync fa-spin"></i>
                                    </div>
                                : ''
                            }
                        </div>
                       
                    </div>                  
                    
                    <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box mb-3">
                            <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-tint"></i></span>

                            <div class="info-box-content">
                                <span class="info-box-text">O.S Em Processo</span>
                                <span class="info-box-number">{this.state.producao}</span>
                            </div>
                            { this.state.isCarregar ? 
                                <div class="overlay d-flex justify-content-center align-items-center">
                                    <i class="fas fa-2x fa-sync fa-spin"></i>
                                </div>
                                : ''
                            }
                        </div>
                    </div>  

                    <div class="col-12 col-sm-6 col-md-3">
                        <div class="info-box mb-3">
                            <span class="info-box-icon bg-success elevation-1"><i class="fas fa-check"></i></span>

                            <div class="info-box-content">
                                <span class="info-box-text">O.S Concluídas</span>
                                <span class="info-box-number">{this.state.pagos}</span>
                            </div>
                            { this.state.isCarregar ? 
                                <div class="overlay d-flex justify-content-center align-items-center">
                                    <i class="fas fa-2x fa-sync fa-spin"></i>
                                    </div>
                                : ''
                            }
                        </div>
                    </div>
                 
                </div>
            </div>
        )
                                
    }
}

export default Painel;
